import axios from 'axios'
import qs from 'qs'
import * as access from '@/config/access'
import * as tool from './tool'
import md5 from 'js-md5'
import key from './secretkey'
let instance = axios.create({ //请求统一实例
    // baseURL: url,
    timeout: 30000
});


const CancelToken = axios.CancelToken;
const source = () => {
    return CancelToken.source()
}

instance.interceptors.response.use(function(response) {
    // 未登录
    /* if(response.data.code == -1){
        location.assign('#/login');
        return;
    } */
    return response;
}, access.catchError);

instance.interceptors.request.use((config) => {
    if (config.method === 'post' || 'get') {
        if (access.session('token')) {
            config.headers.common['Authorization'] = 'Bearer ' + access.session('token').token;
        }
    }
    if (config.responseType === "arraybuffer" && config.method === 'post') {
        config.data = qs.stringify(config.data);
    } //下载文件流需要文件名称 走instance.post或get方法 
    return config;
}, (error) => {
    return Promise.reject(error);
});

const get = (url, params) => {
    url = tool.parseUrl(url);
    let headers = { cancelToken: source().token };
    let keys = Object.keys(params.params);
    if (keys.length > 0) {
        keys.forEach((item, index) => {
            params.params[item] = params.params[item] == null ? '' : params.params[item];
        })
        /* let paramKey = md5(decodeURIComponent(qs.stringify(params.params)) + 'yd_cloud').toLocaleUpperCase();
        headers.headers = { paramKey: paramKey } */
    }
    return new Promise((resolve, reject) => {
        instance.get(url, Object.assign(params, headers))
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}

const put = (url, params) => {
    url = tool.parseUrl(url);;
    return instance({
        method: 'put',
        url: url,
        data: params
    })
}

const dele = (url, params) => {
    url = tool.parseUrl(url);;
    return instance({
        method: 'delete',
        url: url,
        data: params
    })
}

const fetch = (url, params, postType, responseType) => {
    url = tool.parseUrl(url);
    let paramKey = '',
        headers = {};
    if (postType === 'json' || Object.prototype.toString.call(params) === '[object FormData]') {
        // paramKey = md5(JSON.stringify(params) + 'yd_cloud').toLocaleUpperCase();
    } else {
        params = qs.stringify(params, {allowDots: true});
        // paramKey = md5(decodeURIComponent(params) + 'yd_cloud').toLocaleUpperCase();
    }
    /* if (paramKey) {
        headers.headers = { paramKey: paramKey };
    } */
    return new Promise((resolve, reject) => {
        instance.post(url, params, Object.assign({ cancelToken: source().token, responseType }/* , headers */))
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
//跨域方法
const crossDomainReq = (url, params, type, hearder) => {
    url = tool.parseUrl(url);
    crossDomainInstance.interceptors.request.use((config) => {
        if (config.method === 'post' || 'get') {
            if (access.session('token')) {
                config.headers.common['Authorization'] = 'Bearer ' + access.session('token').token;
            }
            config.data = qs.stringify(config.params);
        }
        if (hearder) {
            config.headers = Object.assign(config.headers, hearder)
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    return new Promise((resolve, reject) => {
        let myData, myParams
        const myType = type || 'get'
        crossDomainInstance({
                method: type || 'get',
                url: url,
                params: params || {},
                // data:myData
            }).then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            });
    })
}

//新的请求方法，参数以json格式发送
const jsonReq = function(url, params, type, hearder) {
    let jsonInstance = axios.create(); //请求统一实例
    url = tool.parseUrl(url);
    jsonInstance.interceptors.request.use((config) => {
        if (config.method === 'post' || 'get') {
            if (access.session('token')) {
                config.headers.common['Authorization'] = 'Bearer ' + access.session('token').token;
            }
            if (config.method === 'post' && config.data) {
                config.headers.common['paramKey'] = md5(JSON.stringify(config.data) + 'yd_cloud').toLocaleUpperCase();
            }
        }
        if (hearder) {
            config.headers = Object.assign(config.headers, hearder)
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    return new Promise((resolve, reject) => {
        const config = { method: type, url: url, params: params }
        if (type === 'get') {
            config.params = params
            config.data = {}
        } else if (type === 'post') {
            config.data = params
            config.params = {}
        }
        jsonInstance(config).then(response => {
                return resolve(response.data);
            }, err => {
                return reject(err);
            })
            .catch((error) => {
                return reject(error)
            });
    })
}

export {
    get,
    put,
    dele,
    fetch,
    source,
    crossDomainReq,
    instance,
    // downloadFile,
    jsonReq
}
